import React from 'react';
const points = [{
  emoji: '😰',
  text: 'Llegás a la pista sin saber exactamente qué drill o situación de juego dar hoy'
}, {
  emoji: '⏱️',
  text: 'Tardás horas planificando lo que podrías resolver en segundos con este material'
}, {
  emoji: '🤷',
  text: 'Grupo desparejo o falta un alumno: te bloqueás al adaptar la sesión del día'
}, {
  emoji: '💸',
  text: 'Sin criterios claros: sentís que tus clases son siempre iguales y perdés autoridad profesional'
}, {
  emoji: '😓',
  text: 'Tus alumnos están desmotivados porque sienten que no hay un plan de avance'
}, {
  emoji: '😩',
  text: 'El domingo a la noche seguís estresado preparando la semana'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-99">
      <div className="max-w-3xl mx-auto" data-id="element-100">
        <div className="text-center mb-12" data-id="element-101">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-102">
            👉 ¿Te reconocés en estas situaciones?
          </h2>
          <p className="text-text-sec text-base sm:text-lg" data-id="element-103">
            Si respondés sí a alguna — este pack es para vos
          </p>
        </div>

        <div className="space-y-4 mb-12" data-id="element-104">
          {points.map((point, i) => <div key={i} className="flex items-center gap-4 sm:gap-6 bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light shadow-sm" data-id="element-105">
              <div className="text-3xl sm:text-4xl flex-shrink-0" data-id="element-106">
                {point.emoji}
              </div>
              <p className="text-text-main font-medium text-base sm:text-lg leading-snug" data-id="element-107">
                {point.text}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-108">
          <p className="text-primary font-serif italic text-xl sm:text-2xl font-bold" data-id="element-109">
            Y vos merecés mucho más que eso →
          </p>
        </div>
      </div>
    </section>;
}